import React from "react";
import { DateRangePicker, CustomProvider } from "rsuite";
import "rsuite/dist/rsuite.min.css";

export default function DateTimeRangePicker({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  minDate,
  maxDate,
}) {
  const { afterToday, allowedRange, combine } = DateRangePicker;
  const hasRange = Boolean(startDate && endDate);

  const hasBounds = Boolean(minDate && maxDate);

  const shouldDisableDate = hasBounds
    ? combine(afterToday(), allowedRange(new Date(minDate), new Date(maxDate)))
    : afterToday();

  // Open the calendar on the months where data actually exists, instead of
  // defaulting to today's month, so the user isn't hunting for available dates.
  const defaultCalendarValue = hasBounds && !hasRange
    ? [new Date(minDate), new Date(maxDate)]
    : undefined;

  // One-tap shortcut that marks the collection's actual first/last item
  // dates on the calendar, rather than silently pre-selecting them.
  const ranges = hasBounds
    ? [{ label: "Available Data", value: [new Date(minDate), new Date(maxDate)] }]
    : [];

  const handleChange = (range) => {
    if (range) {
      setStartDate(range[0].toISOString()); // Store as ISO string in UTC
      setEndDate(range[1].toISOString()); // Store as ISO string in UTC
    } else {
      setStartDate(null);
      setEndDate(null);
    }
  };
  return (
    <div className="dateTimeRangePicker">
      <CustomProvider theme="dark">
        <DateRangePicker
          value={hasRange ? [new Date(startDate), new Date(endDate)] : null}
          defaultCalendarValue={defaultCalendarValue}
          ranges={ranges}
          format="yyyy-MM-dd hh:mm:ss a"
          placement="bottomEnd"
          onChange={handleChange}
          showMeridian
          shouldDisableDate={shouldDisableDate}
        />
      </CustomProvider>
    </div>
  );
}
